import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  width: 100vw;
  min-width: 320px;

  margin: 0 auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  list-style-type: none;
  background-color: #c1cac9;
`;
